import { Component, EventEmitter, Output } from '@angular/core';
import { CameraScannerService } from '@core/camera-scanner/camera-scanner.service';
import { ToastController } from '@ionic/angular';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-camera-scan-button',
  templateUrl: './camera-scan-button.component.html',
  styleUrls: ['./camera-scan-button.component.scss'],
})
export class CameraScanButtonComponent {

  @Output() scanResult = new EventEmitter<string>();

  enabled$: Observable<boolean>;
  scanning = false;

  constructor(
    private cameraScannerService: CameraScannerService,
    private toastController: ToastController,
  ) {
    this.enabled$ = this.cameraScannerService.enabled$;
  }

  async scan(): Promise<void> {
    if (this.scanning) return;

    const hasPermission = await this.cameraScannerService.requestPermissions();
    if (!hasPermission) {
      await this._toast('Permissão de câmara negada', 'warning');
      return;
    }

    this.scanning = true;

    this.cameraScannerService.startScan().subscribe({
      next: async (value) => {
        this.scanning = false;
        if (value) {
          await this._toast(`📷 ${value}`, 'success');
          this.scanResult.emit(value);
        }
      },
      error: async (err) => {
        this.scanning = false;
        console.error('[CameraScanButton] Scan error:', err);
        await this._toast(`Erro no scan: ${err?.message ?? err}`, 'danger');
      },
    });
  }

  private async _toast(message: string, color: 'success' | 'warning' | 'danger'): Promise<void> {
    const toast = await this.toastController.create({
      message,
      color,
      duration: 3000,
      position: 'top',
    });
    await toast.present();
  }
}
